export const TRIAL_SOON_DAYS = 7;
export const MS_PER_DAY = 24 * 60 * 60 * 1000;

export const trialDaysLeft = (trialEndsAt: string | null): number | null => {
  if (!trialEndsAt) return null;
  return Math.ceil((new Date(trialEndsAt).getTime() - Date.now()) / MS_PER_DAY);
};
